


































































































































import { Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
export default Vue.component("delivery-time-prompt", {
  data() {
    return {
      staticContent,
    };
  },
  computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    basket() {
      return this.$store.state.basket;
    },
  },
  methods: {
    confirmDeliveryTimeAndSubmit() {
      this.$root.confirmDeliveryTimeAndSubmit();
    },
    changeDeliveryTime(time: string) {
      this.$root.changeDeliveryTime(time);
    },
    closeModal() {
      this.$root.modalToggler("delivery-time-prompt", "hide");
    },
  },
});
